<template>
  <div class="pt-bangdan-body">
    <div class="pt-bangdan-tab-body">
      <span
        v-for="(item, index) in headNav"
        :key="index"
        :class="{ active: tabIndex == index }"
        class="pt-bangdan-tab"
        @click="interact(index, item.url)"
      >
        {{ item.name }}
      </span>
    </div>
    <div class="pt-bangdan-content-body">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      headNav: [
        {
          name: "基本信息",
          url: "/after/setting/info",
        },
        {
          name: "账号绑定",
          url: "/after/setting/bind",
        },
        {
          name: "修改密码",
          url: "/after/setting/revise",
        },
      ],
      tabIndex: 0,
    };
  },
  methods: {
    interact(index, url) {
      this.tabIndex = index;
      this.$router.push(url);
    },
  },
};
</script>

<style lang="less" scoped>
.pt-bangdan-body {
  height: 100%;
  background: #f5f5f5;
  .pt-bangdan-tab-body {
    padding: 0 24px;
    background: #fff;
    display: flex;
    .pt-bangdan-tab {
      height: 56px;
      line-height: 56px;
      border-bottom: 2px solid transparent;
      margin-right: 40px;
      cursor: pointer;
      position: relative;
      display: block;
      &.active {
        border-color: #1abc9c;
        color: #1abc9c;
      }
    }
  }
  .pt-bangdan-content-body {
    height: calc(100% - 56px);
    padding: 24px;
    overflow-y: auto;
  }
}
</style>
